import { render, staticRenderFns } from "./WarehouseArea.vue?vue&type=template&id=02cc8c04&"
import script from "./WarehouseArea.vue?vue&type=script&lang=js&"
export * from "./WarehouseArea.vue?vue&type=script&lang=js&"
import style0 from "./WarehouseArea.vue?vue&type=style&index=0&id=02cc8c04&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports